type AnyRecord = Record<string, any>;

export interface PickerOption {
  id: string;
  label: string;
  body: string;
}

/** Put this deal's resolved stage default first, then every reusable snippet. */
export function orderPickerOptions(
  templates: AnyRecord | undefined,
  slot: string | null,
): PickerOption[] {
  const defaults = templates?.defaults || [];
  const snippets = templates?.snippets || [];
  const options: PickerOption[] = [];

  const currentDefault = slot
    ? defaults.find((item: AnyRecord) => item.slot === slot)
    : null;
  if (currentDefault) {
    options.push({
      id: `default:${currentDefault.slot}`,
      label: `${currentDefault.label} (stage default)`,
      body: currentDefault.body,
    });
  }

  for (const snippet of snippets) {
    options.push({ id: snippet.id, label: snippet.title, body: snippet.body });
  }
  return options;
}
